import { TSchemaBuilder } from "@pages/ManualDocumentV2/core";
import * as Yup from "yup";
import {
  customerSchema,
  documentInfoSchema,
  itemsSchema,
  spainCorrectionCodeSchema,
  taxesSchema,
  totalsSchema,
  uploadSchema,
  vendorSchema,
} from "../../../_shared/schemaHelpers";

export const siiReplacementInvoiceSchema: TSchemaBuilder = (t, ctx) =>
  documentInfoSchema({
    t,
    documentClass: "Invoice",
    poErrorKey: "poNumber_is_required",
    dueDateRequired: true,
    enforceDateOrder: true,
  })
    .concat(spainCorrectionCodeSchema(t, ctx.invoiceType === "regular"))
    .concat(customerSchema(t))
    .concat(vendorSchema(t))
    .concat(itemsSchema(t))
    .concat(taxesSchema(t))
    .concat(totalsSchema(t))
    .concat(uploadSchema()) as Yup.ObjectSchema<any>;
